import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtErr } from "../api";
import AuthShell from "../components/AuthShell";
import { Field } from "../components/bits";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/reset-password", { token: params.get("token"), password }); toast.success("Password updated — sign in"); nav("/login"); }
    catch (err) { setError(fmtErr(err)); }
  };
  return (
    <AuthShell title="Choose a new password" testid="reset-page" footer={<Link to="/login" className="font-semibold text-slate-900 hover:underline">Back to sign in</Link>}>
      <form onSubmit={submit} className="space-y-4">
        <Field label="New password" hint="At least 8 characters."><input data-testid="reset-password" className="input" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} /></Field>
        {error && <div data-testid="reset-error" className="rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
        <button data-testid="reset-submit" className="btn-primary w-full">Update password</button>
      </form>
    </AuthShell>
  );
}
